import React, { ReactNode } from "react";
import ActicaGroup from "../Branding/GroupLogos";
import "./AdminShell.css";

/**
 * AdminShell
 * ----------
 * Shared page chrome used by admin views (header, avatar, content box and branding).
 *
 * Props:
 * - title: main heading
 * - subtitle: optional secondary heading / description
 * - avatar: optional path to decorative avatar (defaults to /assets/avatars/robot-settings.png)
 * - children: inner content for this page
 */

type Props = {
  title?: string;
  subtitle?: string;
  avatar?: string;
  children?: ReactNode;
};

const AdminShell = ({ title = "Digital Escape Rooms", subtitle, avatar = "/assets/avatars/robot-settings.png", children }: Props) => {
  return (
    <>
    <div className="flex-container" style={{ position: 'relative', zIndex: 10 }}>
      <div className="box box-white box-round admin-shell" style={{ minWidth: '900px' }}>
        <div className="header admin-shell__header">
          <img src={avatar} className="header-avatar" alt="" aria-hidden="true" width="130" height="130" />
          <div className="header-text">
            <h1>{title}</h1>
            {subtitle && <h2>{subtitle}</h2>}
          </div>
        </div>

        <div className="admin-shell__content">{children}</div>
      </div>
    </div>
    <ActicaGroup />
    </>
  );
};

export default AdminShell;